/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-04-17 02:41:46
 *
 *******************************************************/
// @flow

export const REVIEWS = [
  {
    name: 'CKXgear',
    stars: 5,
    time: 'About 5 months using the app',
    review:
      '“The Boost plugin offers very interesting features for our website. The support team was also very quick to answer our concerns and make custom changes for us!”'
  },
  {
    name: 'J-Spec Performance',
    stars: 5,
    time: 'About 3 years using the app',
    review:
      '“Wonderful customer service. We had a template customisation request and they instantly did the modification to suit our needs!”'
  },
  {
    name: 'Orimono.eu',
    stars: 5,
    time: 'About 6 years using the app',
    review:
      '“The boost team has put out a very capable app and the team is very helpful and quick helping with any theme compatibility issues etc, highly recommended!”'
  },
  {
    name: 'Kinky',
    stars: 5,
    time: 'About 4 months using the app',
    review:
      '“Superb display, very functional, responsive, adapts to different themes. Super modular and an ultra-responsive support team. Nothing to complain about this app.'
  },
  {
    name: 'Federation',
    stars: 5,
    time: 'About 2 years using the app',
    review:
      '“Incredible customer service. The app itself is easy to use and navigate. The customers respond quickly and help as much as they can. Highly recommend this app.”'
  },
  {
    name: 'Morrison-Dev',
    stars: 5,
    time: 'About 5 months using the app',
    review:
      '“The app is amazing, it presents our PLP in a sequence that highlights our collection beautifully and is easy to navigate. Highly recommended.”'
  }
];
